import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format, parseISO } from 'date-fns';
import * as locale from 'date-fns/locale';
import { CarIcon } from '../../icons';
import { mapStepToMessage, mapStepToText } from '../../utils/helper';

const OrderedCardOverView = ({ carData }) => {
  const navigate = useNavigate();

  const { subTitle, state, requestDate, title, cncode } = carData || {};

  const { status, message, step, substatus } = state || {};

  return (
    <div className="max-lg:hidden flex flex-col bg-white justify-between h-[70vh] p-6 rounded-lg h-full">
      <div className="flex flex-col gap-y-8 ">
        <div className="flex flex-col gap-6">
          <h3>{title}</h3>
          <div className="flex flex-col gap-2">
            <div className="flex items-center  gap-3">
              <CarIcon color="black" />
              <span className="text-body">{subTitle}</span>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-label text-fadedgrey">
              Ημερ/νία Προσφοράς
            </span>
            <div className="text-body">
              {format(parseISO(requestDate), 'dd MMMM yyyy', {
                locale: locale['el'],
              })}
            </div>
          </div>
        </div>
        {status && (
          <div className="flex flex-col gap-2">
            <span className="text-label text-fadedgrey">Σε εκκρεμότητα</span>
            <div className="text-body">{mapStepToText(step)}</div>
          </div>
        )}
        {message && (
          <div className="text-body">
            {mapStepToMessage(step, substatus) || message}
          </div>
        )}
      </div>
      {!carData.isLegacy && carData.source === 'intermediate' && <button
        type="button"
        disabled={!cncode}
        className="btn-primary text-primary-button w-full text-center"
        onClick={() => navigate(`/track-your-car/details/${cncode}`)}
      >
        Ολοκλήρωση
      </button>
      }
    </div>
  );
};

export const OrderedCarOverViewMobile = ({ carData }) => {
  const navigate = useNavigate();

  const { state, requestDate, title, cncode } = carData || {};
  const { status, message, step, substatus } = state || {};

  return (
    <div className="lg:hidden fixed bottom-0 w-full h-fit bg-white flex flex-col gap-3 p-3">
      <div className="flex flex-col gap-2">
        <div className="flex justify-between">
          <h3>{title}</h3>
          {!carData.isLegacy && carData.source === 'intermediate' && <button
            type="button"
            disabled={!cncode}
            className="text-link text-primary"
            onClick={() => navigate(`/track-your-car/details/${cncode}`)}
          >
            Ολοκλήρωση
          </button>
          }
        </div>
        <div className="flex gap-2 pb-2">
          <div className="flex flex-col gap-2 items-center justify-center">
            <span className="text-body text-fadedgrey">Κωδικός Προσφοράς</span>
            <div className="text-body">{cncode}</div>
          </div>
          <div className="flex flex-col gap-2 items-center justify-center">
            <span className="text-body text-fadedgrey">Ημερ/νία Προσφοράς</span>
            <div className="text-body">
              {format(parseISO(requestDate), 'dd MMMM yyyy', {
                locale: locale['el'],
              })}
            </div>
          </div>
          {status && (
            <div className="flex flex-col gap-2">
              <span className="text-label text-fadedgrey"> Σε εκκρεμότητα</span>
              <div className="text-body">{mapStepToText(step)}</div>
            </div>
          )}
        </div>

        {message && (
          <div className="text-body">
            {mapStepToMessage(step, substatus) || message}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderedCardOverView;
